import { Button, Divider, Paper, Typography } from '@mui/material';
import MuiModal, {ModalProps} from '@mui/material/Modal';
import { CSSProperties, Fragment } from 'react';

export const Modal = (props: ModalProps & {
    title?: string
    onConfirm?: () => void
    confirmLabel?: string
    bodyCustomCss?: CSSProperties
    onCancel?: () => void
    cancelLabel?: string
}) => {
    return (
        <MuiModal {...props}>
            <Paper sx={{
                position: 'absolute' as 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                boxShadow: 24,     
            }}>
                {props.title ? (
                <Fragment>
                    <div style={{
                        padding: 15
                    }}>
                        <Typography variant="h6">
                            {props.title}
                        </Typography>
                    </div>
                <Divider />
                </Fragment>
                ) : null}
                <div style={{padding: 15, ...(props.bodyCustomCss || {})}}>
                    {props.children}
                </div>
                {(props.onConfirm || props.onCancel) ? (
                <Fragment>
                <Divider />
                    <div style={{
                        padding: 15,
                        display: 'flex',
                        justifyContent: props.onConfirm && props.onCancel ? 'space-between' : 'flex-end'
                    }}>
                        {props.onCancel && <Button onClick={props.onCancel} variant='text'>{props.cancelLabel}</Button>}
                        {props.onConfirm && <Button onClick={props.onConfirm} variant='contained'>{props.confirmLabel}</Button>}
                    </div>
                </Fragment>
                ) : null}
            </Paper>
        </MuiModal>
    )
}